'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSortedAlbums = exports.processAlbum = exports.getAllTracks = exports.getPlaylistsTracks = exports.getAlbumsById = exports.processAlbums = exports.getPartTracks = exports.processTracks = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _values = require('babel-runtime/core-js/object/values');

var _values2 = _interopRequireDefault(_values);

var _reselect = require('reselect');

var _Playlists = require('../helpers/Playlists');

var _TypeCast = require('helpers/TypeCast');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getTracks = function getTracks(state) {
  return (0, _TypeCast.asArray)(state.playlist.playlistData.tracks);
}; /* Playlists and albums reselect */

var getAlbum = function getAlbum(state) {
  return (0, _TypeCast.asObject)(state.playlist.playlistData.album);
};
var getPlaylists = function getPlaylists(state) {
  return state.playlists.playlistsData;
};
var getActiveOrder = function getActiveOrder(state) {
  return state.playlists.activeOrder;
};
var getOrder = function getOrder(state) {
  return state.playlists.order;
};
var getKw = function getKw(state) {
  return state.playlists.kw;
};

var processTracks = exports.processTracks = (0, _reselect.createSelector)([getTracks, getAlbum], function (tracks, album) {
  return (0, _Playlists.processTracks)({ tracks: tracks, album: album });
});

var getPartTracks = exports.getPartTracks = (0, _reselect.createSelector)([processTracks], function (tracks) {
  return (0, _Playlists.getPartTracks)(tracks);
});

var processAlbums = exports.processAlbums = (0, _reselect.createSelector)([getPlaylists], function (playlists) {
  var _ref = playlists || { albums: [] },
      albums = _ref.albums;

  return (0, _Playlists.processAlbums)(albums);
});

var getAlbumsById = exports.getAlbumsById = (0, _reselect.createSelector)([getPlaylists], function (playlists) {
  var _ref2 = playlists || { albums: [] },
      albums = _ref2.albums;

  var albumsById = {};
  (0, _values2.default)(albums).map(function (album) {
    return albumsById[album.project_id] = (0, _Playlists.processAlbums)(album);
  });
  return albumsById;
});

var getPlaylistsTracks = exports.getPlaylistsTracks = (0, _reselect.createSelector)([getPlaylists, getAlbumsById], function (playlists, albumsById) {
  var _ref3 = playlists || { tracks: {} },
      tracks = _ref3.tracks;

  var processedTracks = {};
  (0, _entries2.default)(tracks).map(function (_ref4) {
    var _ref5 = (0, _slicedToArray3.default)(_ref4, 2),
        albumId = _ref5[0],
        albumTracks = _ref5[1];

    var album = albumsById[albumId];
    processedTracks[albumId] = (0, _Playlists.processTracks)({ tracks: (0, _TypeCast.asArray)(albumTracks), albumId: Number(albumId), album: album });
  });
  return processedTracks;
});

var getAllTracks = exports.getAllTracks = (0, _reselect.createSelector)([getPlaylistsTracks], function (albumsTracks) {
  var processedTracks = {};
  (0, _values2.default)(albumsTracks).map(function (albumTracks) {
    albumTracks.map(function (albumTrack) {
      processedTracks[albumTrack.id] = albumTrack;
    });
  });
  return processedTracks;
});

var processAlbum = exports.processAlbum = (0, _reselect.createSelector)([getAlbum], function (album) {
  return (0, _Playlists.processAlbums)(album);
});

var getSortedAlbums = exports.getSortedAlbums = (0, _reselect.createSelector)([processAlbums, getActiveOrder, getOrder, getKw], function (albums, activeOrder, order, kw) {
  return (0, _Playlists.getSortedAlbums)((0, _Playlists.getFilteredAlbums)(albums, kw), activeOrder, order);
});


//////////////////
// WEBPACK FOOTER
// ./src/selectors/playlists.js
// module id = 362
// module chunks = 1